import { motion } from 'framer-motion';
import { END_ANIMATION_PROPERTY, START_ANIMATION_PROPERTY, VIEWPORT_PROPERTY } from 'constants/animation-properties';

const Second = ({ data }: any) => {

  return (
    <>
      {
        data.architecture &&
        <section className='pb-24 tablet:pb-8 container'>
          <motion.h2
            className='mb-8 font-semibold text-40 text-black tablet:text-2xl'
            initial={START_ANIMATION_PROPERTY}
            whileInView={END_ANIMATION_PROPERTY}
            viewport={VIEWPORT_PROPERTY} >
            Information Architecture
          </motion.h2>

          <motion.img
            src={data.architecture}
            transition={{ delay: 0.2 }}
            alt="architecture"
            initial={START_ANIMATION_PROPERTY}
            whileInView={END_ANIMATION_PROPERTY}
            viewport={VIEWPORT_PROPERTY} >
          </motion.img>
        </section>
      }

      {
        data.wireFrame &&
        <section className='pb-24 tablet:pb-8 container'>
          <motion.h2
            className='mb-8 font-semibold text-40 text-black tablet:text-2xl'
            initial={START_ANIMATION_PROPERTY}
            whileInView={END_ANIMATION_PROPERTY}
            viewport={VIEWPORT_PROPERTY} >
            {
              data.id === 4 ?
                'Dashboard Scenario' :
                'Wireframe Architecture'
            }
          </motion.h2>

          <motion.img
            src={data.wireFrame}
            transition={{ delay: 0.2 }}
            alt="architecture"
            initial={START_ANIMATION_PROPERTY}
            whileInView={END_ANIMATION_PROPERTY}
            viewport={VIEWPORT_PROPERTY} >
          </motion.img>
        </section>
      }
    </>
  )
}

export default Second
